(function AllInclusivePropertiesView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/AllInclusiveProperties/otherOfferContactForm/', function onload() {
			$('.offer-terms-modal').click(function termsModal(e) {
				e.preventDefault();
				
				let $self  = $(this),
					$modal = $('#modalWindow');

				e.preventDefault();

				$modal.find('.modal-title').text($self.data('modal-title'));
				$modal.find('.modal-body').html($self.data('modal-body'));
				$modal.modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));